
export interface MedicalCentersRespsonse {
    centrosMedicos: MedicalCenter[];
    indVacio: boolean;
    indPrimero: boolean;
    indUltimo: boolean;
    numeroPagina: string;
    numeroElementos: string;
    tamanyo: string;
    totalElementos: string;
    totalPaginas: string;
    indMapfreSalud: boolean;
    indUrgencias: boolean;
    indCitaOnline: boolean;
    indEspecialidadExcepcionada: boolean;
}

export interface MedicalCenter {
    selected: boolean;
    codigoCentroMedicoMapfre: string;
    codigoTitular: string;
    codigoMinisterio: string;
    codigoCentroMedicoTuoTempo: string;
    nombreCentroMedico: string;
    nombreWeb: string;
    codigoPais: string;
    descripcionPais: string;
    codigoComunidadAutonoma: string;
    descipcionComunidadAutonoma: string;
    codigoProvincia: string;
    descripcionProvincia: string;
    codigoPoblacion: string;
    descripcionPoblacion: string;
    codigoPostal: string;
    codigoTipoVia: string;
    descripcionTipoVia: string;
    nombreVia: string;
    numeroVia: string;
    escalera: string;
    piso: string;
    puerta: string;
    latitud: string;
    longitud: string;
    distancia: string;
    precision: string;
    telefonoFijoPrincipal: string;
    telefonoFijoSecundario: string;
    telefonoMovil: string;
    email: string;
    indCitaOnline: boolean;
    anyoAlta: string;
    mesAlta: string;
    diaAlta: string;
    anyoBaja: string;
    mesBaja: string;
    diaBaja: string;
    indMapfreSalud: boolean;
    indUrgencias: boolean;
    observaciones: string;
    videoconsulta: boolean;
    serviciosConcertados: ServiciosConcertado[];
    indEspecialidadExcepcionada: boolean;
}

export interface ServiciosConcertado {
    codigo: string;
    videoconsulta: boolean;
    codigoEspecialidad: string;
    nombreEspecialidad: string;
    telefonos: string;
    horarios: string;
    medicinaPreventiva: MedicinaPreventiva;
    programaPreventivo: string;
    descripcionProgramaPreventivo: string;
    tratamientoEspecial: MedicinaPreventiva;
    tipoServicioEspecial: string;
    descripcionServicioEspecial: string;
    peticionPrevia: MedicinaPreventiva;
    observaciones: string;
    ordenPreferente: string;
    indCitaOnline: boolean;
    anyoAlta: string;
    mesAlta: string;
    diaAlta: string;
    anyoBaja: string;
    mesBaja: string;
    diaBaja: string;
    profesionalesSanitarios: Partial<ProfesionalesSanitario>[];
    subespecialidades: Partial<Subespecialidade>[];
    actosMedicos: ActosMedico[];
}

export interface ActosMedico {
    codigoActoMedico: string;
    descripcionActoMedico: string;
    indCitaOnline: boolean;
    regionesAnatomicas: RegionesAnatomicas[];
}

export type MedicinaPreventiva = 'N' | 'S';

export interface ServiciosConcertadoProfesionalesSanitario {
    codigoProfesionalSanitario: string;
    nombreProfesionalSanitario: string;
}

export interface Subespecialidade {
    codigoSubespecialidad: string;
    descripcionSubespecialidad: string;
    indCitaOnline: boolean;
    profesionalesSanitarios: Partial<ProfesionalesSanitario>[];
}

export interface SubespecialidadeProfesionalesSanitario {
}

export type SpecialityResponse = Speciality[];
export interface Speciality {
    codigoEspecialidad: string;
    descripcionEspecialidad: string;
    indCitaOnline: boolean;
    profesionalesSanitarios: ProfesionalesSanitario;
    subespecialidades: Subespecialidade[];
    actosMedicos: ActosMedico[];
}
export interface ActosMedico {
    codigoActoMedico: string;
    descripcionActoMedico: string;
    indCitaOnline: boolean;
}
export interface ProfesionalesSanitario {
    videoconsulta: boolean;
}
export interface Subespecialidade {
    codigoSubespecialidad: string;
    descripcionSubespecialidad: string;
    indCitaOnline: boolean;
    profesionalesSanitarios: Partial<ProfesionalesSanitario>[];
    subespecialidades: any[];
    actosMedicos: any[];
    observaciones: string;
}
export interface ProfesionalesSanitario {
    codigoProfesionalSanitario: string;
    nombreProfesionalSanitario: string;
}
export interface SearchEngineItem {
    icono: boolean;
    imagenTarjetaEscritorio: string;
    imagenTarjetaMovil: string;
    tituloTarjeta: string;
    url: string;
}

export interface SearchEngineResponse {
    buscadoresPorGuiaMedica: {
        codigoGuiaMedica: string,
        listaBuscadores: string[];
    }[];
}

export interface MedicalGuide {
    codigoGuiaMedica: string;
    descripcionGuiaMedica: string;
    codigoProductoGenerico: string;
    descripcionProductoGenerico: string;
    descripcionComercial: string,
    importe: string,
    caracteristicas: string[];
}
export interface MedicalDoctorsResponse {
    facultativos: Facultativo[];
    indVacio: boolean;
    indPrimero: boolean;
    indUltimo: boolean;
    numeroPagina: string;
    numeroElementos: string;
    tamanyo: string;
    totalElementos: string;
    totalPaginas: string;
    indCitaOnline: boolean;
    indMapfreSalud: boolean;
    indUrgencias: boolean;
}

export interface Facultativo {
    selected: boolean;
    codigoProfesionalSanitario: string;
    nombreProfesionalSanitario: string;
    codigoCentroMedicoMapfre: string;
    codigoTitular: string;
    codigoMinisterio: string;
    codigoCentroMedicoTuoTempo: string;
    nombreCentroMedico: string;
    nombreWeb: string;
    codigoPais: string;
    descripcionPais: string;
    codigoComunidadAutonoma: string;
    descipcionComunidadAutonoma: string;
    codigoProvincia: string;
    descripcionProvincia: string;
    codigoPoblacion: string;
    descripcionPoblacion: string;
    codigoPostal: string;
    codigoTipoVia: string;
    descripcionTipoVia: string;
    nombreVia: string;
    numeroVia: string;
    escalera: string;
    piso: string;
    puerta: string;
    latitud: string;
    longitud: string;
    distancia: string;
    precision: string;
    telefonoFijoPrincipal: string;
    telefonoFijoSecundario: string;
    telefonoMovil: string;
    email: string;
    anyoAlta: string;
    mesAlta: string;
    diaAlta: string;
    anyoBaja: string;
    mesBaja: string;
    diaBaja: string;
    indMapfreSalud: boolean;
    observaciones: string;
    serviciosConcertados: ServiciosConcertado[];
    videoconsulta: boolean;
}

export interface ServiciosConcertado {
    codigo: string;
    codigoEspecialidad: string;
    nombreEspecialidad: string;
    observaciones: string;
    indCitaOnline: boolean;
    subespecialidades: Partial<Subespecialidade>[];
    actosMedicos: ActosMedico[];
    videoconsulta: boolean;
}

export interface ActosMedico {
    codigoActoMedico: string;
    descripcionActoMedico: string;
}

export interface PruebasDiagnosticas {
    codigo: string;
    descripcion: string;
    regionesAnatomicas: RegionesAnatomicas[];
}
export interface RegionesAnatomicas {
    codigo: string;
    descripcion: string;
}

export type UrlServicePath = 'pruebasDiagnosticas';

export enum Context {
  FE = 'buscadores_fe-web',
  BE = 'buscadores_be-web'
}


